import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function Home() {

    var [showGuides, setShowGuides] = useState(false);
    var handleShowGuides = () => setShowGuides(!showGuides);

    useEffect(() => {
        if (sessionStorage.getItem('afs')) {
            sessionStorage.removeItem('afs');
        }
        if(sessionStorage.getItem('mfs')){
            sessionStorage.removeItem('mfs');
        }
        if(sessionStorage.getItem('sfs')){
            sessionStorage.removeItem('sfs');
        }
    }, []);

    return (
        <section id="Home">
            <div className="container-fluid mt-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 box-viewRequest">
                            <Link to={'/login'} className="d-flex align-items-center justify-content-center w-100 h-100">
                                <div className="box-image">
                                    <img src="./images/icn-viewrequest.png" className="img-responsive" alt="" />
                                </div>
                                <div className="guide-inner-content ps-3">
                                    <p className="biaoti">View My Request(s)</p>
                                    <p>View my Past & Current Request(s)</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 box-marriage box-child">
                            <Link to={'/marriage/disclaimer'} className="d-block w-100 h-100">
                                <div className="box-image">
                                    <img src="./images/icn-Marriage.png" className="img-responsive" alt="" />
                                </div>
                                <div className="guide-inner-content ps-3">
                                    <p className="biaoti">Marriage<br /> Records</p>
                                    <p>Request for Marriage Records Search</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-6 box-school box-child">
                            <Link to={'/school/disclaimer'} className="d-block w-100 h-100">
                                <div className="box-image">
                                    <img src="./images/icn-School.png" className="img-responsive" alt="" />
                                </div>
                                <div className="guide-inner-content ps-3">
                                    <p className="biaoti">School<br /> Records</p>
                                    <p>Request for School Records Search</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 box-archival box-child">
                            <Link to={'/archival/disclaimer'} className="d-block w-100 h-100">
                                <div className="box-image">
                                    <img src="./images/icn-Content.png" className="img-responsive" alt="" />
                                </div>
                                <div className="guide-inner-content ps-3">
                                    <p className="biaoti">Archival Records<br /> Request</p>
                                    <p>Request to View or Reproduce Archival Records</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-6 box-pictureSg box-child">
                            <Link to={'/picturesg/disclaimer'} className="d-block w-100 h-100">
                                <div className="box-image">
                                    <img src="./images/icn-pictureSG.png" className="img-responsive" alt="" />
                                </div>
                                <div className="guide-inner-content ps-3">
                                    <p className="biaoti">Images from National<br /> Library, Singapore</p>
                                    <p>Request a copy</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={showGuides ? 'row box-guide active' : 'row box-guide'}>
                        <div className="col-md-12 p-0 d-flex flex-row flex-wrap flex-md-nowrap">
                            <div className="box-guide-content d-flex justify-content-center align-items-center" onClick={handleShowGuides}>
                                <p className="biaoti m-0 text-light">Guides to Submit Request</p>
                            </div>
                            <div className="box-guide-list">
                                <ul className="list-unstyled h-100">
                                    <li><Link to="/school/guide"><span>Request for School Record</span></Link></li>
                                    <li><Link to="/marriage/guide">Request for Marriage Record</Link></li>
                                    <li><Link to="/archival/guide">Request for Archival Records</Link></li>
                                    <li><Link to="/picturesg/guide">Request for Images from National Library, Singapore</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row box-faq">
                        <div className="col-md-6 box-faq-content">
                            <Link to={'/faq'} className="biaoti text-light d-flex justify-content-center align-items-center w-100 h-100">
                                <div>Frequently Asked Questions <img src="./images/icn-FAQ.png" className="ms-3 d-lg-inline-block d-none" alt="" /></div>
                            </Link>
                        </div>
                        <div className="col-md-6 box-faq-content">
                            <a href="https://www.nas.gov.sg/archivesonline/contact" target="_blank" rel="noreferrer" className="biaoti text-light d-flex justify-content-center align-items-center w-100 h-100">
                                Contact Us <img src="./images/icn-AskforHelp.png" className="ms-3" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





